<div class="skeleton-cards-container">
  @for (i of items; track i) {
  <div class="skeleton-card">
    <!-- Header: nombre + monto -->
    <div class="skeleton-header">
      <ion-skeleton-text animated class="skeleton-name" />
      <ion-skeleton-text animated class="skeleton-amount" />
    </div>
    <!-- Meta: tickets + asistentes -->
    <div class="skeleton-meta">
      <ion-skeleton-text animated class="skeleton-meta-line" />
    </div>
    <!-- Progress bar -->
    <div class="skeleton-progress">
      <ion-skeleton-text animated class="skeleton-bar" />
      <div class="skeleton-progress-info">
        <ion-skeleton-text animated class="skeleton-info-left" />
        <ion-skeleton-text animated class="skeleton-info-right" />
      </div>
    </div>
  </div>
  }
</div>
